export function namespaceTeamsForLaunchDarkly(brandSlug: string, teams: string[]): string[] {
    if (!brandSlug) {
        return [];
    }

    return teams.map((team) => `${brandSlug}-${team}`);
}
